/**
 * Camera-level Case/Scan scope. Never show raw `_camera_scope`.
 * Never pretend camera-level scope is a physical zone.
 */

export const CAMERA_LEVEL_SCOPE_LABEL = 'Camera-level scope';

const CAMERA_SCOPE_TOKENS = [
  '_camera_scope',
  'camera_scope',
  'camera-level scope',
  'camera-level',
  'camera level scope',
];

export function isCameraLevelScope(value?: string | null): boolean {
  const text = String(value || '').trim().toLowerCase();
  if (!text) return false;
  return CAMERA_SCOPE_TOKENS.includes(text) || text.replace(/\s+/g, '_') === '_camera_scope';
}

export function formatCameraLevelScope(args: {
  siteArea?: string | null;
  cameraLabel?: string | null;
  cameraId?: string | null;
}): string {
  const camera = String(args.cameraLabel || '').trim();
  const cameraId = String(args.cameraId || '').trim();
  if (isCameraLevelScope(args.siteArea) || (!String(args.siteArea || '').trim() && (camera || cameraId))) {
    if (camera && !isCameraLevelScope(camera)) {
      return `${CAMERA_LEVEL_SCOPE_LABEL} · Camera: ${camera}`;
    }
    return CAMERA_LEVEL_SCOPE_LABEL;
  }
  const area = String(args.siteArea || '').trim();
  if (isCameraLevelScope(area)) return CAMERA_LEVEL_SCOPE_LABEL;
  return area;
}

export function caseIssueLocationLines(args: {
  issue: string;
  siteArea?: string | null;
  cameraLabel?: string | null;
  cameraId?: string | null;
}): { issue: string; location: string } {
  return {
    issue: String(args.issue || '').trim() || '—',
    location: formatCameraLevelScope({
      siteArea: args.siteArea,
      cameraLabel: args.cameraLabel,
      cameraId: args.cameraId,
    }) || '—',
  };
}
